import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import Formsy from 'formsy-react';
import { ChevronDown, ExternalLink, PlusIcon } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem, Tabs, TabsContent, TabsList, TabsTrigger, Row, Col, Button, Label, FormGroup, FormSection, ButtonGroup, SheetBody, SheetFooter, DefaultTooltip } from 'twyne-new.ui'

import GroupOptions from 'components/GroupOptions';
import URLView from 'components/InputCopyURL';
import Checkbox from 'components/form/Checkbox';
import Inputy from 'components/form/Input';
import Select from 'components/form/Select';

class URLGenerator extends React.Component {
  constructor(props) {
    super(props)
    const { formOptions, offersOptions } = this.getFormOfferOptions(props)
    this.state = {
      siteDomain: props.siteData.domain,
      allocationId: props.allocationData.id,
      publisherId: props.allocationData.publisher_id,
      slug: props.allocationData.slug,
      url: "",
      https: true,
      parameters: [],
      invalidParameters: [],
      formOptions,
      offersOptions,
      formId: null,
      offerId: null,
    }
  }

  getFormOfferOptions(props) {
    let formOptions = []; let offersOptions = []

    if (props.forms) {
      const allocationForms = Object.values(props.allocationData.forms).filter(item => !!item).map(item => [...item]).flat()
      const allocationFormsIds = allocationForms.map(item => item.id)
      const allForms = props.forms.map(item => ({ label: item.name, value: item.id }))
      const allocationFormsOptions = allForms.filter(item => allocationFormsIds.includes(item.value))
      formOptions = allocationFormsOptions
    }

    if (props.offers) {
      const allocationOffers = props.allocationData.offers
      const allocationOffersIds = allocationOffers.map(item => item.id)
      const allOffers = props.offers.map(item => ({ label: item.name, value: item.id }))
      const allocationOffersOptions = allOffers.filter(item => allocationOffersIds.includes(item.value))
      offersOptions = allocationOffersOptions
    }

    return { formOptions, offersOptions }
  }

  encodeBase64Url(data) {
    return encodeURIComponent(btoa(data))
  }

  prepingParametersTemplate = [['email', 'email/md5'], 'lastseen']
  allocationParametersTemplate = ["first_name", "last_name", "email", "address1", "address2", "city", "state", "zip", "phone", "gender", "dob", "sid1", "sid2", "externalid", "campaignid", "externalstatus"]
  get parametersTemplate() {
    return this.props.isPreping ? this.prepingParametersTemplate : this.allocationParametersTemplate
  }
  getPrepingURL = ({ https, siteDomain, include_aid, allocationId, publisherId }) => `${https ? 'https' : 'http'}://${siteDomain}/api/ping/check?${include_aid ? `aid=${allocationId}&` : ''}pid=${publisherId}`
  getAllocationURL = ({ https, siteDomain, with_slug, allocationId, publisherId, slug }) => {
    const http = https ? 'https' : 'http'
    const searchParams = with_slug ? `slug=${slug}` : `aid=${allocationId}&pid=${publisherId}`
    return `${http}://${siteDomain}/lmain?${searchParams}`
  }
  getSplitURL = ({ https, siteDomain, allocationId, publisherId, formId, offerId }) => {
    let url = `${https ? 'https' : 'http'}://${siteDomain}/lmain?aid=${allocationId}&pid=${publisherId}`
    if (formId) {
      const valueToHash = `fid:${formId.toString()}`
      url += `&__testab_form=${this.encodeBase64Url(valueToHash)}`
    }

    if (offerId) {
      const valueToHash = `oid:${offerId.toString()}`
      url += `&__testab_offer=${this.encodeBase64Url(valueToHash)}`
    }

    return url
  }

  componentDidMount() {
    this.handleSubmit()
  }

  addOption = template => {
    this.hangleChange(({ parameters }) => {
      if (template === 'all') {
        return { parameters: this.parametersTemplate.map(p => Array.isArray(p) ? { value: p[0], label: `{${p[1]}}` } : { value: p, label: `{${p}}` }) }
      }

      const parameter = { value: '', label: '' }
      if (template !== undefined) {
        if (parameters.findIndex(item => item.value === template) >= 0) {
          return { parameters }
        }
        let label = `{${template}}`
        if (Array.isArray(template)) {
          [template, label] = template
        }
        parameter.value = template
        parameter.label = label
        parameter.disabled = true
      }
      parameters.push(parameter);
      return { parameters };
    });
  }

  validateParameters = (itemi, i, arr) => {
    let label; let value;

    if (!itemi.value) {
      value = "The key can not be empty."
    } else if (arr.find((itemj, j) => itemj.value === itemi.value && i !== j)) {
      value = "The key must be unique."
    }
    if (!itemi.label) {
      label = "The value can not be empty."
    }
    return label || value ? { label, value } : undefined;
  }

  isInvalidParameters = () => {
    const invalidParameters = this.state.parameters.map(this.validateParameters);
    this.setState({ invalidParameters })
    const isInvalid = invalidParameters.some(item => !!item);
    return isInvalid
  }

  hangleChange(state) {
    this.setState(prevState => {
      state = state || {}
      if (typeof state === 'function') {
        state = state(prevState)
      }
      state.url = ''
      return state
    })
  }

  handleSubmit = () => {
    if (this.isInvalidParameters()) {
      return;
    }

    let url = this.props.isPreping ? this.getPrepingURL(this.state) : this.props.isSplit ? this.getSplitURL(this.state) : this.getAllocationURL(this.state)

    this.state.parameters.forEach(param => {
      url += `&${param.value}=${param.label}`
    })

    this.setState({ url })
  }

  PublisherParameter = () => <Col size="3">
    <FormGroup>
      <Label>PID</Label>
      <Inputy name="pid" value={this.state.publisherId} disabled />
    </FormGroup>
  </Col>

  AllocationParameter = () => {
    if (this.props.isPreping && !this.state.include_aid) {
      return null
    }

    return <Col size="3">
      <FormGroup>
        <Label>AID</Label>
        <Inputy name="aid" value={this.state.allocationId} disabled />
      </FormGroup>
    </Col>
  }

  SlugParameter = () => <Col size="6">
    <FormGroup>
      <Label>Slug</Label>
      <Inputy name="slug" value={this.state.slug} disabled />
    </FormGroup>
  </Col>

  Parameters = () => {
    if (this.state.with_slug) {
      return <this.SlugParameter />
    }

    return <>
      <this.AllocationParameter />
      <this.PublisherParameter />
    </>
  }

  render() {
    return <>
      <div className='p-4'>
        <Row className="mb-4">
          <Col size="2">
            <Checkbox name="https" title="HTTPS" value={this.state.https} setValue={https => this.setState({ https })} />
          </Col>
          {!this.props.isPreping ? <Col size="2">
            <Checkbox name="with_slug" title="Slug" value={this.state.with_slug} setValue={with_slug => this.setState({ with_slug })} disabled={!this.state.slug} />
          </Col> : null}
          {this.props.isPreping ? <Col size="4">
            <Checkbox title="Include Allocation" value={this.state.include_aid}
              name="include_aid" setValue={include_aid => this.setState({ include_aid })} />
          </Col> : null}
        </Row>
        <Row>
          <Col size="6">
            <FormGroup>
              <Label>Domain</Label>
              <SelectDomain required
                value={this.state.siteDomain}
                handleOnChange={opt => {
                  opt && this.setState({ siteDomain: opt.value })
                }}
                siteData={this.props.siteData}
              />
            </FormGroup>
          </Col>
          <this.Parameters />
          {this.props.isSplit && <>
            <Col size="6">
              <FormGroup>
                <Label>Offer</Label>
                <Select
                  name="_"
                  value={this.state.offerId}
                  options={this.state.offersOptions}
                  handleOnChange={option => this.setState({ offerId: option ? option.value : null })}
                />
              </FormGroup>
            </Col>
            <Col size="6">
              <FormGroup>
                <Label>Form</Label>
                <Select
                  name="_"
                  value={this.state.formId}
                  options={this.state.formOptions}
                  handleOnChange={option => this.setState({ formId: option ? option.value : null })}
                />
              </FormGroup>
            </Col>
          </>}
          <Col size="12">
            <div className="float-right flex gap-2">
              <ButtonGroup>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button size="sm" variant='outline' color="accent" className='flex items-center'>
                      Template
                      <ChevronDown size={12} />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className='max-h-[50vh] overflow-y-auto'>
                    <DropdownMenuItem key="all" onClick={() => this.addOption("all")}>All Fields</DropdownMenuItem>
                    {this.parametersTemplate.map(param => <>
                      {param === 'externalstatus' ? <DefaultTooltip content={`Lead Status preset. When Twyne (or any sender) calls Path's 'lmain' endpoint, the accepted values for the status are exactly: accepted, duplicated, rejected, optout, scrub. Any value outside this list will not be recognized.`} triggerProps={{ asChild: true }}><DropdownMenuItem key={param} onClick={() => this.addOption(param)}>{param}</DropdownMenuItem></DefaultTooltip> : <DropdownMenuItem key={param} onClick={() => this.addOption(param)}>{param}</DropdownMenuItem>}
                    </>)}
                  </DropdownMenuContent>
                </DropdownMenu>
                <Button size="sm" color="accent" onClick={() => this.addOption()}>
                  <PlusIcon size={12} />
                  Add
                </Button>
              </ButtonGroup>
            </div>
            <FormSection>
              Optional fields
            </FormSection>
          </Col>
          <Col size='12'>
            <GroupOptions
              handleChange={() => this.hangleChange()}
              options={this.state.parameters}
              invalidOptions={this.state.invalidParameters}
            />
          </Col>
          <Col size='12'>
            <FormGroup>
              <URLView value={this.state.url} />
            </FormGroup>
          </Col>
        </Row>
      </div>
      <SheetFooter>
        <Button color='accent' variant='light' onClick={() => window.open(this.state.url, '_blank')}>
          <ExternalLink size={16} /> Open in a new tab
        </Button>
        <Button color="accent" onClick={this.handleSubmit}>Generate</Button>
      </SheetFooter>
    </>
  }
}

class URLGeneratorForm extends React.Component {
  render() {
    if (typeof this.props.open === "boolean" && !this.props.open) return null
    return (
      <Formsy>
        <Tabs defaultValue='details'>
          <TabsList className='px-4'>
            <TabsTrigger value='details'>
              Allocation
            </TabsTrigger>
            <TabsTrigger value='preping'>
              Preping
            </TabsTrigger>
            <TabsTrigger value='testPreview'>
              Test A/B Preview
            </TabsTrigger>
          </TabsList>
          <TabsContent value='details'>
            <URLGenerator
              siteData={this.props.siteData}
              allocationData={this.props.allocationData}
            />
          </TabsContent>
          <TabsContent value='preping'>
            <URLGenerator
              isPreping={true}
              siteData={this.props.siteData}
              allocationData={this.props.allocationData}
            />
          </TabsContent>
          <TabsContent value='testPreview'>
            <URLGenerator
              isSplit={true}
              siteData={this.props.siteData}
              allocationData={this.props.allocationData}
              offers={this.props.offers}
              forms={this.props.forms}
            />
          </TabsContent>
        </Tabs>
      </Formsy>
    );
  }
}

URLGeneratorForm.propTypes = {
  allocationData: PropTypes.any,
  siteData: PropTypes.any,
  onCancel: PropTypes.func,
};

export default URLGeneratorForm;

function SelectDomain({ siteData, ...props }) {
  const [siteDomainOptions, setSiteDomainOptions] = useState([])

  useEffect(() => {
    if (!siteData) return;
    const options = [siteData.domain]
      .concat(JSON.parse(`[${siteData.domain_aliases || ''}]`))
      .filter(domain => domain && !domain.startsWith('*.'))
      .map(domain => ({ label: domain, value: domain }));
    setSiteDomainOptions(options)
  }, [siteData])

  return <Select
    {...props}
    disabled={siteDomainOptions.length <= 1}
    clearable={false}
    name="domain"
    options={siteDomainOptions}
  />
}
